import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./components/App";
import Spinner from "./components/Spinner";

console.log(`Account Wrapper v${APP_VERSION}`);

const container = document.getElementById("wrapper-root");
const root = createRoot(container);
root.render(
    <Suspense fallback={<Spinner />}>
        <App />
    </Suspense>
);
